import './App.css';
import FAQ from './components/FAQ';
import Financing from './components/Financing';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import PrivacyPolicy from './components/PrivacyPolicy';


function App() {
  return (
    <div className="App">
      <Navbar />
      <PrivacyPolicy />
      <FAQ />
      <Financing />
      <Footer />
    </div>
  );
}

export default App;
